define('orderdDetailCompositionView',[
  'module',
  'marionette',
  'underscore',
  'orderdDetailCompositionController'
], function (
  Module,
  Marionette,
  _,
  Controller
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: _.template('<div class="view-region"></div>'),
    className: 'order-detail-composition-view',

    regions: {
      viewRegion: '.view-region'
    },

    onShow: function () {              
      Controller.showCompositionTab(this.getRegion('viewRegion'), 
        this.model.get('order'), this.options.customer, this.model.get('product'));
    }     
  });
});
